import { CdkTableModule } from '@angular/cdk/table';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';

import { TreeModule } from '@ali-hm/angular-tree-component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AngularMyDatePickerModule } from 'gramli-angular-mydatepicker';

import { AutoselectDirectiveModule } from '@directives';

import { CastPipeModule, I18nPipeModule } from '../../pipes';
import { SharedModule } from '../shared/shared.module';
import { BasedataComponent } from './detail/basedata/basedata.component';
import { ContactsComponent } from './detail/basedata/contacts/contacts.component';
import { CardComponent } from './detail/card/card.component';
import { CertificationComponent } from './detail/certification/certification.component';
import { ConditionsComponent } from './detail/contractdata/conditions/conditions.component';
import { DeliverytermsComponent } from './detail/contractdata/conditions/deliveryterms/deliveryterms.component';
import { ContractdataComponent } from './detail/contractdata/contractdata.component';
import { DiscountsComponent } from './detail/contractdata/discounts/discounts.component';
import { DetailComponent } from './detail/detail.component';
import { CustomerratingsComponent } from './detail/ratings/customerratings/customerratings.component';
import { RatingsComponent } from './detail/ratings/ratings.component';
import { OverviewComponent } from './overview/overview.component';
import { SupplierRoutingModule } from './supplier-routing.module';

@NgModule({
    declarations: [
        DetailComponent,
        OverviewComponent,
        BasedataComponent,
        CardComponent,
        ConditionsComponent,
        CertificationComponent,
        DiscountsComponent,
        RatingsComponent,
        ContractdataComponent,
        ContactsComponent,
        DeliverytermsComponent,
        CustomerratingsComponent,
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,

        SupplierRoutingModule,
        SharedModule, // @TODO: get rid of it
        I18nPipeModule,

        AngularMyDatePickerModule,
        NgbModule,
        MatTableModule,
        CdkTableModule,
        TreeModule,
        CastPipeModule,
        AutoselectDirectiveModule,
    ],
    exports: [BasedataComponent, CardComponent, ContactsComponent],
})
export class SupplierModule {}
